(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 8228:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(8499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function BlogArticleLabels(param) {
    var title = param.title, estimate = param.estimate, date = param.date;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "info mb-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "px-2 text-white bg-gray-400 text-[10px] uppercase inline-block rounded-lg",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "py-1 pl-4 pr-2 text-gray-600 text-xs inline-block",
                children: [
                    estimate,
                    " mins read"
                ]
            }),
            "•",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "py-1 pl-2 text-gray-600 text-xs inline-block ",
                children: date
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogArticleLabels);


/***/ }),

/***/ 1791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _share_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8326);
/* harmony import */ var _blog_article_labels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3587);






function BlogArticleList(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.data.map(function(a) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "mb-24",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/blog/articles/".concat(a.attributes.slug),
                        title: a.attributes.title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "relative flex w-full aspect-video mb-4 rounded-md overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                layout: "fill",
                                width: a.attributes.image.data.attributeswidth,
                                height: a.attributes.image.data.attributesheight,
                                src: a.attributes.image.data.attributes.url,
                                alt: a.attributes.title,
                                sizes: "(max-width: 768px) 50vw, 100vw",
                                priority: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "info mb-4 text-maturity-300",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blog_article_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            title: a.attributes.blog_category.data.attributes.title,
                            estimate: a.attributes.estimate,
                            date: a.attributes.date
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-semibold !text-2xl leading-[2rem] text-left !my-0",
                        children: a.attributes.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "pb-2 text-left",
                        children: a.attributes.summary
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-grow order-1 md:order-0 py-4 md:py-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/blog/articles/".concat(a.attributes.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        title: a.attributes.title,
                                        className: "btn trust-border",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "flaticon-next text-xs mr-2"
                                            }),
                                            "Read full article"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex order-0 md:order-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_share_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    title: a.attributes.title,
                                    url: "/blog/articles/".concat(a.attributes.slug),
                                    body: a.attributes.summary
                                })
                            })
                        ]
                    })
                ]
            }, "article-".concat(a.id));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogArticleList);


/***/ }),

/***/ 2508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



function BlogCategoryList(param) {
    var selected = param.selected, categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col relative w-full mb-4 order-3 lg:order-none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "flex !text-[1rem] font-bold uppercase mb-4 !mt-0",
                    children: "Categories"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: "flex flex-col list-none border-b border-gray-100",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "!list-none !mx-0 !p-0",
                            children: [
                                selected === "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "block p-4 border-t border-gray-100 w-full bg-gray-100 text-trust",
                                    children: "All categories"
                                }),
                                selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "block p-4 border-t border-gray-100 w-full hover:bg-gray-100",
                                        children: "All categories"
                                    })
                                })
                            ]
                        }, "blog-category-all"),
                        categories.map(function(cat) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: "!list-none !mx-0 !p-0",
                                children: [
                                    selected === cat.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "block p-4 border-t border-gray-100 w-full bg-gray-100 text-trust",
                                        children: [
                                            cat.title,
                                            "  (",
                                            cat.articleCount,
                                            ")"
                                        ]
                                    }),
                                    selected !== cat.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/blog/categories/".concat(cat.slug, "/1"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "block p-4 border-t border-gray-100 w-full hover:bg-gray-100",
                                            children: [
                                                cat.title,
                                                " (",
                                                cat.articleCount,
                                                ")"
                                            ]
                                        })
                                    })
                                ]
                            }, "blog-category-".concat(cat.id));
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogCategoryList);


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroSubpage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4761);


function HeroSubpage(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "header-subpage relative ".concat(props.headerCss ? props.headerCss : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative subpage-gradient w-full",
                    children: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.data) ? props.imageAsBackground ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute z-1 top-0 w-full h-full opacity-50 bg-blend-soft-light bg-no-repeat bg-cover bg-center",
                                style: {
                                    backgroundImage: "url(".concat(props.image.data.attributes.url, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container py-[12rem] relative z-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center justify-start ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col w-full p-10 md:w-2/3 text-white justify-start ".concat(props.contentCss ? props.contentCss : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: props.content
                                        }
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start py-[10rem]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex w-2/5 mx-auto md:w-1/2 relative z-20 pl-8 justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-start",
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start pt-[6rem] pb-[6rem]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-10 ".concat(!props.full ? "md:w-2/3" : "", " text-white justify-start"),
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "skew-bottom"
                })
            ]
        })
    });
}


/***/ }),

/***/ 7809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



function pageNumbers(currentPage, totalPages, displayPages) {
    // Create an array to store page numbers
    var pageNumbers = [];
    var startPage, endPage;
    if (totalPages <= displayPages) {
        startPage = 1;
        endPage = totalPages;
    } else {
        if (currentPage <= Math.ceil(displayPages / 2)) {
            startPage = 1;
            endPage = displayPages - 1;
        } else if (currentPage + Math.floor(displayPages / 2) >= totalPages) {
            startPage = totalPages - displayPages + 2;
            endPage = totalPages;
        } else {
            startPage = currentPage - Math.ceil(displayPages / 2) + 1;
            endPage = currentPage + Math.floor(displayPages / 2);
        }
    }
    if (startPage > 2) pageNumbers.push(1, "...");
    for(var i = startPage; i <= endPage; i++){
        pageNumbers.push(i);
    }
    if (endPage < totalPages - 1) pageNumbers.push("...", totalPages);
    // Return the array of page numbers
    return pageNumbers;
}
function PagionationNumber(param) {
    var page = param.page, i = param.i, url = param.url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            i == page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "px-4 font-bold",
                children: i
            }, "pagination-page-active-".concat(i.toString())),
            i != page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(url, "/").concat(i),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "px-4",
                    children: i
                })
            }, "pagination-page-".concat(i.toString()))
        ]
    });
}
function Pagination(param) {
    var url = param.url, _pagination = param.pagination, page = _pagination.page, pageCount = _pagination.pageCount;
    var displayPages = 5;
    var range = pageNumbers(page, pageCount, displayPages);
    if (range.length == 1) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pagination",
        children: [
            page > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(url, "/").concat(page - 1),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: "pr-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "flaticon-back text-[8px]"
                        }),
                        " Previous"
                    ]
                })
            }, "pagination-prev-button"),
            range.map(function(i, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PagionationNumber, {
                    url: url,
                    page: page,
                    i: i
                }, "pagination-".concat(index));
            }),
            page < pageCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(url).concat(page ? "/" + (page + 1) : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: "pl-4",
                    children: [
                        "Next ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "flaticon-next text-[8px]"
                        })
                    ]
                })
            }, "pagination-next-button")
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PhotoGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1129);
/* harmony import */ var fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fslightbox_react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5439);
/* harmony import */ var _section_title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5715);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6017);








function PhotoGallery(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), toggler = ref[0], setToggler = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), slide = ref1[0], setSlide = ref1[1];
    var ref2 = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)(), state = ref2.state, dispatch = ref2.dispatch;
    var photos = props.photos.data.map(function(p) {
        return p.attributes.mime === "video/mp4" ? {
            type: "video",
            src: p.attributes.url,
            caption: p.attributes.caption,
            thumb: ""
        } : {
            type: "image",
            width: p.attributes.width,
            height: p.attributes.height,
            image: {
                data: p
            },
            src: p.attributes.url,
            thumb: p.attributes.formats.thumbnail.url,
            caption: p.attributes.caption
        };
    });
    var limit = props.visibleSlides || photos.length;
    var gallery = photos.slice(0, limit);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (props.title || props.desciption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section_title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: props.title,
                description: props.description,
                className: "w-full md:w-1/2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "gallery relative ".concat(props.type ? props.type : "", " ").concat(props.className ? props.className : "", " ").concat(gallery.length === 1 ? "cols-1" : ""),
                children: gallery.map(function(p, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        "data-id": index,
                        className: "relative w-full aspect-[4/3]",
                        onClick: function() {
                            setSlide(index + 1);
                            setToggler(!toggler);
                        },
                        children: [
                            p.type === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(p.image),
                                alt: p.image.data.attributes.alternativeText || "",
                                layout: "fill",
                                priority: !index ? true : false,
                                quality: 85,
                                className: "object-cover"
                            }),
                            p.type === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                muted: false,
                                autoPlay: true,
                                playsInline: true,
                                src: p.src
                            }),
                            p.type === "video" && gallery.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "absolute top-[calc(50%-2.5rem)] text-[5rem] left-[calc(50%-2.5rem)] text-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "flaticon-youtube"
                                })
                            })
                        ]
                    }, "slide-".concat(index));
                })
            }),
            gallery.length < photos.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "continue relative w-full h-full justify-center items-center flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn maturity-border",
                    onClick: function() {
                        return setToggler(!toggler);
                    },
                    children: "View all photos"
                })
            }, "slide-last"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((fslightbox_react__WEBPACK_IMPORTED_MODULE_3___default()), {
                showThumbsOnMount: true,
                toggler: toggler,
                sources: photos.map(function(p) {
                    return p.src;
                }),
                types: photos.map(function(p) {
                    return p.type;
                }),
                thumbs: photos.map(function(p) {
                    return p.thumb;
                }),
                captions: photos.map(function(p) {
                    return p.caption;
                }),
                slide: slide,
                onOpen: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: true
                    });
                },
                onClose: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: false
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 8326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1818);



function ShareIcons(param) {
    var title = param.title, body = param.body, url = param.url;
    var shareUrl = "".concat("https://www.arka-parcel-lockers.com").concat(url);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .FacebookShareButton */ .Dk, {
                url: shareUrl,
                quote: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .FacebookIcon */ .Vq, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TwitterShareButton */ .B, {
                url: shareUrl,
                title: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TwitterIcon */ .Zm, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .LinkedinShareButton */ .r2, {
                url: shareUrl,
                title: title,
                summary: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .LinkedinIcon */ .pA, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TumblrShareButton */ .SZ, {
                url: shareUrl,
                title: title,
                caption: body,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .TumblrIcon */ .OA, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: "mr-2 mb-2 border border-gray-300 rounded-[50px]"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .RedditShareButton */ .iR, {
                url: shareUrl,
                title: title,
                windowWidth: 660,
                windowHeight: 460,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_2__/* .RedditIcon */ .MP, {
                    bgStyle: {
                        fill: "#fff"
                    },
                    iconFillColor: "#ccc",
                    size: 32,
                    round: true,
                    className: " mb-2 border border-gray-300 rounded-[50px]"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShareIcons);


/***/ }),

/***/ 8499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/client-list.jsx + 2 modules
var client_list = __webpack_require__(5864);
// EXTERNAL MODULE: ./components/features.jsx + 11 modules
var features = __webpack_require__(5997);
// EXTERNAL MODULE: ./components/title.jsx
var title = __webpack_require__(3086);
// EXTERNAL MODULE: ./components/layout.jsx + 5 modules
var layout = __webpack_require__(5726);
// EXTERNAL MODULE: ./components/hero-section.jsx
var hero_section = __webpack_require__(753);
// EXTERNAL MODULE: ./components/hero-subpage.jsx
var hero_subpage = __webpack_require__(5467);
// EXTERNAL MODULE: ./components/photo-gallery.jsx
var photo_gallery = __webpack_require__(604);
// EXTERNAL MODULE: ./components/contact-block.jsx
var contact_block = __webpack_require__(7410);
// EXTERNAL MODULE: ./components/content-box-list.jsx
var content_box_list = __webpack_require__(7654);
// EXTERNAL MODULE: ./components/team.jsx + 1 modules
var team = __webpack_require__(4506);
// EXTERNAL MODULE: ./components/form.jsx + 1 modules
var components_form = __webpack_require__(7518);
// EXTERNAL MODULE: ./components/event-list.jsx
var event_list = __webpack_require__(4598);
// EXTERNAL MODULE: ./components/news-list.jsx
var news_list = __webpack_require__(1890);
// EXTERNAL MODULE: ./components/event-featured.jsx
var event_featured = __webpack_require__(3188);
// EXTERNAL MODULE: ./components/blog-articles-list.jsx
var blog_articles_list = __webpack_require__(1791);
// EXTERNAL MODULE: ./components/pagination.jsx
var pagination = __webpack_require__(7809);
// EXTERNAL MODULE: ./components/blog-category-list.jsx
var blog_category_list = __webpack_require__(2508);
// EXTERNAL MODULE: ./components/large-box.jsx + 2 modules
var large_box = __webpack_require__(626);
// EXTERNAL MODULE: ./components/cta-box.jsx
var cta_box = __webpack_require__(2443);
// EXTERNAL MODULE: ./components/job-list.jsx
var job_list = __webpack_require__(9733);
// EXTERNAL MODULE: ./components/testimonial-list.jsx
var testimonial_list = __webpack_require__(3550);
// EXTERNAL MODULE: ./components/hero-video.jsx
var hero_video = __webpack_require__(1833);
// EXTERNAL MODULE: ./lib/helper.js
var helper = __webpack_require__(4994);
// EXTERNAL MODULE: ./lib/global-context.js
var global_context = __webpack_require__(5439);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./lib/seo-context.js
var seo_context = __webpack_require__(4449);
// EXTERNAL MODULE: ./components/section-title.jsx
var section_title = __webpack_require__(5715);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(6017);
// EXTERNAL MODULE: ./node_modules/fslightbox-react/index.js
var fslightbox_react = __webpack_require__(1129);
var fslightbox_react_default = /*#__PURE__*/__webpack_require__.n(fslightbox_react);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/showcase-box.jsx






function ShowcaseBox(props) {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), toggler = ref2[0], setToggler = ref2[1];
    var ref3 = (0,react.useState)(1), slide = ref3[0], setSlide = ref3[1];
    var ref4 = (0,global_context/* useGlobalContext */.bN)(), state = ref4.state, dispatch = ref4.dispatch;
    var photos = ((ref = props.photos) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.length) ? props.photos.data.map(function(p) {
        return {
            type: "image",
            width: p.attributes.width,
            height: p.attributes.height,
            image: {
                data: p
            },
            src: p.attributes.url,
            thumb: p.attributes.formats.thumbnail.url,
            caption: p.attributes.caption
        };
    }) : [];
    var gallery = photos.length ? photos.slice(0, 4) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "showcase-box container mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "showcase-box-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex text-trust text-2xl font-bold",
                                dangerouslySetInnerHTML: {
                                    __html: props.title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "showcase-description w-full columns-1 lg:columns-2 lg:mr-8",
                                        dangerouslySetInnerHTML: {
                                            __html: props.description
                                        }
                                    }),
                                    props.icons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-start lg:justify-center items-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "showcase-icons flex flex-row flex-wrap gap-4 lg:w-48",
                                            children: props.icons.map(function(i, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center rounded-md bg-white bg-opacity-10 w-20 h-20 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "flex flaticon-".concat(i.icon, "  text-5xl ")
                                                    })
                                                }, "icon-".concat(idx));
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    gallery.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col lg:flex-row bg-black bg-opacity-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "showcase-box-wrapper flex flex-col lg:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex flex-row flex-wrap gap-4 w-full lg:w-5/6 ",
                                    children: gallery.map(function(p, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "data-id": index,
                                            className: "flex w-[calc(50%-0.5rem)] md:w-[calc(25%-1rem)] aspect-video relative rounded-md overflow-hidden hover:opacity-40",
                                            onClick: function() {
                                                setSlide(index + 1);
                                                setToggler(!toggler);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (0,media/* default */.Z)(p.image),
                                                alt: p.image.data.attributes.alternativeText || "",
                                                layout: "fill",
                                                priority: !index ? true : false,
                                                quality: 85,
                                                className: "object-cover w-full"
                                            })
                                        }, "img-".concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-auto lg:w-1/6 flex-row justify-start lg:justify-end items-center py-4 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn action-full",
                                        onClick: function() {
                                            return setToggler(!toggler);
                                        },
                                        children: "View gallery"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            photos.length && /*#__PURE__*/ (0,jsx_runtime.jsx)((fslightbox_react_default()), {
                showThumbsOnMount: true,
                toggler: toggler,
                sources: photos.map(function(p) {
                    return p.src;
                }),
                types: photos.map(function(p) {
                    return p.type;
                }),
                thumbs: photos.map(function(p) {
                    return p.thumb;
                }),
                captions: photos.map(function(p) {
                    return p.caption;
                }),
                slide: slide,
                onOpen: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: true
                    });
                },
                onClose: function() {
                    return dispatch({
                        type: "GALLERY",
                        payload: false
                    });
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/showcase-box-list.jsx




function ShowcaseBoxList(props) {
    var title = props.title, boxes = props.boxes;
    // console.log(props);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "showcase-box-list ".concat(props.css ? props.css : ""),
        children: [
            props.featureListCss === "bg-net" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-top"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "showcase-box-list-wrapper",
                children: props.boxes.map(function(box, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseBox, (0,_object_spread/* default */.Z)({}, box), "showcasebox-".concat(idx));
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/enhanced-content-block.jsx


function EnhancedContentBlock(props) {
    var _sectionCss;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (_sectionCss = props.sectionCss) !== null && _sectionCss !== void 0 ? _sectionCss : props.sectionCss,
        children: [
            props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: props.titleCss,
                dangerouslySetInnerHTML: {
                    __html: props.title
                }
            }, "ecb-".concat(props.id)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container px-4 xl:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(props.contentCss),
                    dangerouslySetInnerHTML: {
                        __html: props.content
                    }
                })
            })
        ]
    }, "ecb-section-" + props.id);
}

// EXTERNAL MODULE: ./node_modules/react-slideshow-image/dist/react-slideshow-image.esm.js + 2 modules
var react_slideshow_image_esm = __webpack_require__(5135);
// EXTERNAL MODULE: ./node_modules/react-slideshow-image/dist/styles.css
var styles = __webpack_require__(9180);
// EXTERNAL MODULE: ./components/photo.jsx
var photo = __webpack_require__(4761);
;// CONCATENATED MODULE: ./components/slider.jsx







function Slider(props) {
    var ref;
    var slideshowSettings = {
        autoplay: false,
        showThumbs: false,
        indicators: props.showIndicators,
        infinite: props.infiniteLoop,
        cssClass: props.sliderCss ? props.sliderCss + "relative aspect-video w-full" : "relative aspect-video w-full rounded-xl shadow-lg",
        duration: props.duration * 1000,
        transitionDuration: props.transitionDuration * 1000,
        arrows: props.showArrows,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "text-gray-300 w-9 h-9 hover:text-action ml-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "flaticon-left-arrow pointer-events-none text-4xl"
            })
        }),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "text-gray-300 w-9 h-9 z-20 hover:text-action mr-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: " flaticon-right-arrow pointer-events-none text-4xl"
            })
        })
    };
    return ((ref = props.photos.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "slider ".concat(props.sectionCss),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container px-4 xl:px-0 relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Effect, {
                settings: slideshowSettings,
                animation: props.animation,
                children: props.photos.data.map(function(slide, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "slider-slide",
                        children: [
                            slide.attributes.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "slider-caption",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: slide.attributes.caption
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                                layout: "intrinsic",
                                quality: 100,
                                objectFit: slide.attributes.width > slide.attributes.height ? "cover" : "contain",
                                image: {
                                    data: slide
                                }
                            })
                        ]
                    }, slide.id.toString());
                })
            })
        })
    });
}
var Effect = function(param) {
    var animation = param.animation, settings = param.settings, children = param.children;
    if (animation === "slide") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slideshow_image_esm/* Slide */.Mi, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: children
        }));
    }
    if (animation === "zoom-in") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slideshow_image_esm/* Zoom */.LG, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            scale: 1.4
        }, settings), {
            children: children
        }));
    }
    if (animation === "zoom-out") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slideshow_image_esm/* Zoom */.LG, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            scale: 0.7
        }, settings), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slideshow_image_esm/* Fade */.pT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./pages/[slug].jsx

































var Page = function(props) {
    var state = (0,global_context/* useGlobalContext */.bN)().state;
    var global = state;
    var pageProps = props.pageProps;
    var router = (0,next_router.useRouter)();
    var page = 1;
    if (!pageProps) {
        return "";
    }
    var seo = pageProps && pageProps.seo ? (0,helper/* Merge */.$U)(global.seo, pageProps.seo) : global.seo;
    seo.canonicalURL = "".concat("https://www.arka-parcel-lockers.com", "/").concat(pageProps.slug);
    var footerClass = "skew-maturity-100";
    if (pageProps) {
        pageProps.sections.map(function(s) {
            if (s.__component.includes("layout.form-section")) footerClass = "skew-maturity-100";
        });
    }
    // pageProps.sections.map((s) => {
    //     console.log(s.__component)
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_context/* default.Provider */.Z.Provider, {
        value: seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            footerClass: footerClass,
            languageData: {
                originalSlug: pageProps.originalSlug,
                languages: pageProps.localizations
            },
            children: [
                pageProps.header[0] && pageProps.header[0].__component === "layout.hero-video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_video/* default */.Z, (0,_object_spread/* default */.Z)({}, pageProps.header[0])),
                pageProps.header[0] && pageProps.header[0].__component === "layout.hero" && /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_subpage/* default */.Z, (0,_object_spread/* default */.Z)({
                    full: true
                }, pageProps.header[0]), "hero-subpage-header"),
                pageProps.sections.map(function(section, index) {
                    switch(section.__component){
                        case "layout.feature-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(features/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "feature-list-".concat(index));
                        case "layout.large-box":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(large_box/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "large-box-".concat(section.__component, "-").concat(section.id, "-").concat(index));
                        case "layout.title":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "title-box-".concat(section.id));
                        case "layout.cta":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cta_box/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "cta-box-".concat(section.id));
                        case "layout.testimonial-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_list/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "test-".concat(section.__component, "-").concat(section.id, "-").concat(index));
                        case "layout.client-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(client_list/* default */.Z, {
                                settings: section
                            }, "cli" + section.id);
                        case "layout.hero":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "hero-subpage-".concat(section.id));
                        case "layout.showcase-box-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseBoxList, (0,_object_spread/* default */.Z)({}, section), "showcase-box-list");
                        case "layout.slider":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, (0,_object_spread/* default */.Z)({}, section), "slider-".concat(section.id));
                        case "layout.joblist":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(job_list/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "job-list");
                        case "layout.gallery":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container content-light-bg py-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(photo_gallery/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
                                    className: "px-10 "
                                }), "gallery-".concat(section.id))
                            });
                        case "layout.events-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(event_featured/* default */.Z, {
                                        events: pageProps.events
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(event_list/* default */.Z, (0,_object_spread/* default */.Z)({
                                        events: pageProps.events
                                    }, section))
                                ]
                            }, "event-list");
                        case "layout.news-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(news_list/* default */.Z, (0,_object_spread/* default */.Z)({
                                news: pageProps.news
                            }, section), "news-list");
                        case "layout.contact-block":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_block/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "contact-block");
                        // case 'layout.form-section':
                        //     return (
                        //         <section key={'feat-' + section.id}>
                        //             <div className="relative bg-maturity-100 pt-20 mt-20">
                        //                 <div className="skew-top"></div>
                        //                 <div className="container z-20 relative -top-20">
                        //                     <GoogleReCaptchaProvider
                        //                         reCaptchaKey={process.env.NEXT_PUBLIC_RECAPCHA_SITE_KEY}
                        //                         language={router.locale}
                        //                         scriptProps={{
                        //                             async: false,
                        //                             defer: false,
                        //                             appendTo: 'head'
                        //                         }}
                        //                     >
                        //                         <Form
                        //                             key={'feat' + section.id}
                        //                             {...section.form.data.attributes.form}
                        //                         ></Form>
                        //                     </GoogleReCaptchaProvider>
                        //                 </div>
                        //             </div>
                        //         </section>
                        //     );
                        case "layout.form-section":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative bg-gray-100 py-20 mt-20",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container z-20 relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                                            reCaptchaKey: "6Ld9odIjAAAAAJkiHOsNv-L532Hfg2eOgM8L3RN6",
                                            language: router.locale,
                                            scriptProps: {
                                                async: false,
                                                defer: false,
                                                appendTo: "head"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* default */.Z, (0,_object_spread/* default */.Z)({}, section.form.data.attributes.form), "feat" + section.id)
                                        })
                                    })
                                })
                            }, "form-section-" + section.id);
                        case "layout.content-block":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container p-10 content",
                                        dangerouslySetInnerHTML: {
                                            __html: section.content
                                        }
                                    })
                                })
                            }, "content-" + section.id);
                        case "layout.enhanced-content-block":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EnhancedContentBlock, (0,_object_spread/* default */.Z)({}, section), "slug-ecb-".concat(section.id));
                        case "layout.team-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(team/* default */.Z, {
                                    people: section.people.data
                                })
                            }, "content-" + section.id);
                        case "layout.content-box-list":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_box_list/* default */.Z, (0,_object_spread/* default */.Z)({}, section), "slug-ContentBoxList-".concat(section.id));
                        case "layout.blog-articles":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "container mx-auto content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col lg:flex-row p-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col w-full lg:w-2/3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "articles ".concat(page == 1 ? "with-featured" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_articles_list/* default */.Z, (0,_object_spread/* default */.Z)({}, pageProps.articles))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex mt-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                                        url: "/blog",
                                                        pagination: pageProps.articles.meta.pagination
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col w-full lg:w-1/3 lg:pl-10 relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sticky top-24 w-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_category_list/* default */.Z, {
                                                    selected: "",
                                                    categories: pageProps.categories
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, "blog-articles");
                    }
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [660,396,535,489,512,818,915,726,793,518,973,730,774,888,179], function() { return __webpack_exec__(8228); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);